import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WelcomePageComponent } from './shared/components/welcome-page/welcome-page.component';

const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomePageComponent
  },
  {
    path: '',
    loadChildren: () => import('./rendering-3d/rendering-3d.module')
        .then(mod => mod.Rendering3dModule)
  },
  // {
  //   path: 'iframe',
  //   loadChildren: () => import('./iframes/iframes.module')
  //     .then(mod => mod.IframesModule)
  // },
  // {
  //   path: 'coming-soon',
  //   loadChildren: () => import('./shared/modules/countdown-timer/countdown-timer.module')
  //     .then(mod => mod.CountdownTimerModule)
  // },
  // {
  //   path: 'registration',
  //   loadChildren: () => import('./shared/modules/registration/registration.module')
  //       .then(mod => mod.RegistrationModule)
  // },
  // {
  //   path: '**',
  //   redirectTo: '',
  //   pathMatch: 'full'
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    useHash: false
  })],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
